<template>
  <div class="uk-flex uk-flex-middle" uk-height-viewport>
    <div class="uk-width-3-3@m uk-width-1-3@s m-auto rounded">
      <div class="uk-child-width-2-2@m uk-grid-collapse" uk-grid>
        <div class="uk-card-default p-5 rounded">
          <div class="mb-4 text-center">
            <h3 class="mb-3">E-posta Adresi Doğrulama</h3>

            <!-- Success Message -->
            <div v-if="successMessage" class="uk-alert-success" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:green;">
                <i class="uil-check-circle"></i> {{ successMessage }}
              </p>
            </div>

            <!-- Error Message -->
            <div v-if="errorMessage" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;">
                <i class="uil-exclamation-triangle"></i> {{ errorMessage }}
              </p>
            </div>


            <!-- Main Content -->
            <div v-if="!isVerified">

              <!-- Email Icon -->
              <div class="text-center mb-4">
                <i class="uil-envelope" style="font-size: 4rem; color: #6c757d;"></i>
              </div>

              <p class="mb-3">
                Hesabınızı doğrulamak için
                <strong style="color: #28a745;">{{ email }}</strong>
                adresinize bir doğrulama bağlantısı gönderdik.
              </p>

              <p class="mb-4 text-muted">
                E-posta kutunuzu kontrol ederek doğrulama bağlantısına tıklayın.
              </p>

              <!-- Resend Button -->
              <button :disabled="isLoading" class="btn mb-3 btn-primary" style="background-color: #6e00ff !important" type="button"
                @click="resendVerification">
                <span v-if="isLoading">
                  <i class="uil-spinner-alt uk-spin"></i> Gönderiliyor...
                </span>
                <span v-else>
                  <i class="uil-envelope"></i> Doğrulama Bağlantısını Yeniden Gönder
                </span>
              </button>


              <p class="mb-4 text-muted">
                Doğrulama işlemini gerçekleştirdiyseniz butona tıklayarak giriş sayfasından sisteme giriş yapabilirsiniz
              </p>


              <!-- Login Button -->
              <div class="mt-4">
                <button class="btn btn-success" style="background-color: #36b37e !important" type="button" @click="goToLogin">
                  <i class="uil-sign-in-alt"></i> Giriş Yap
                </button>
              </div>
            </div>

            <!-- Verified Success -->
            <div v-else>
              <div class="text-center mb-4">
                <i class="uil-check-circle" style="font-size: 4rem; color: #28a745;"></i>
              </div>
              <p class="mb-4 text-success">
                E-posta adresiniz başarıyla doğrulandı!
              </p>
              <button class="btn btn-success" type="button" @click="goToLogin">
                <i class="uil-sign-in-alt"></i> Giriş Sayfasına Git
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "EmailVerification",
  data() {
    return {
      email: '',
      token: '',
      isVerified: false,
      isLoading: false,
      successMessage: '',
      errorMessage: '',
    }
  },
  computed: {
    verificationUrl() {
      const url = this.$route.query.url;
      return typeof url === 'string' && url.trim() ? url : null;
    }
  },
  methods: {
    async verifyEmail() {
      if (!this.verificationUrl) {
        this.errorMessage = 'Geçersiz doğrulama bağlantısı.';
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        const response = await ApiService.get(this.verificationUrl);

        if (response.data.is_verify) {
          this.isVerified = true;
          this.successMessage = response.data.message;
        } else {
          this.errorMessage = response.data.message;
        }
      } catch (error) {
        this.errorMessage = error.response?.data?.message || 'E-posta doğrulama işlemi başarısız oldu.';
      } finally {
        this.isLoading = false;
      }
    },

    async resendVerification() {
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        const response = await ApiService.post("api/email/verification-notification", {
          email: this.email,
          alias: this.$route.query.alias,
          token: this.token
        });

        this.successMessage = response.data.message;
      } catch (error) {
        this.errorMessage = error.response?.data?.message || 'Doğrulama bağlantısı gönderilemedi.';
      } finally {
        this.isLoading = false;
      }
    },

    goToLogin() {
      this.$router.push({ name: 'login' });
    }
  },
  async mounted() {
    this.token = this.$route.query.token || '';
    this.email = this.$route.query.email || '';

    // Eğer URL parametresi varsa doğrulama yap
    if (this.verificationUrl) {
      await this.verifyEmail();
    }
  }
}
</script>

<style scoped>
.uk-spin {
  animation: uk-spin 1s linear infinite;
}

@keyframes uk-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
